module.exports = __webpack_public_path__ + "media/tema_2_pstañas_b_sympathetic_CF1.886f057d.wav";